import httpService from "./httpService";

export default {
  insert(form) {
    return httpService.post("tkTask", form);
  },

  findAll(form) {
    return httpService.post("tkTask", form);
  },

  findById(id) {
    return httpService.get("tkTask/" + id);
  },

  findByIdAndUserDeptRoleId(id, userDeptRoleId) {
    return httpService.get("tkTask/findByIdAndUserDeptRoleId/" + id, {
      params: { userDeptRoleId: userDeptRoleId }
    });
  },

  findAllByParentId(id) {
    return httpService.get(`tkTask/${id}/findAllChildTask`);
  },

  changeDeadline(taskId, changeDeadlineForm) {
    return httpService.put(
      `tkTask/${taskId}/changeDeadline`,
      changeDeadlineForm
    );
  },

  update(id, form) {
    return httpService.put(`tkTask/${id}`, form);
  },

  approveTask(taskId) {
    return httpService.put(`tkTask/${taskId}/approveTask`);
  },

  finishTask(form, taskId) {
    return httpService.put(`tkTask/${taskId}/finishTask`, form);
  },

  approveCompletedTask(form, taskId) {
    return httpService.put(`tkTask/${taskId}/approveCompletedTask`, form || {});
  },

  refuseCompletedTask(form, taskId) {
    return httpService.put(`tkTask/${taskId}/refuseCompletedTask`, form);
  },

  /**
   * tu choi dang ki;
   * @param taskId
   * @param form
   * @returns {*}
   */
  refuseTask(taskId, form) {
    return httpService.put(`tkTask/${taskId}/refuseTask`, form);
  },

  cancelTask(taskId, form) {
    return httpService.put(`tkTask/${taskId}/cancelTask`, form);
  },

  pauseTask(taskId, form) {
    return httpService.put(`tkTask/${taskId}/pauseTask`, form);
  },

  resumeTask(taskId, form) {
    return httpService.put(`tkTask/${taskId}/resumeTask`, form);
  },

  changeReceiver(taskId, form) {
    return httpService.put(`tkTask/${taskId}/changeReceiver`, form);
  },

  delete(id, form) {
    return httpService.delete(`tkTask/${id}`, { data: form });
  }
};



// WEBPACK FOOTER //
// ./src/services/tkTaskService.js